module.exports = __webpack_public_path__ + "static/img/par1.f795282.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/par_game/par1.png
// module id = B++w
// module chunks = 0